<template>
  <div>
    <div class="page-title">Edit Content Section</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Content Section"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.content-sections.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.ContentSection.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.ContentSection.update(this.form);
      this.$router.push("/widgets/content-sections");
    },
  },
};
</script>

<style scoped lang="scss"></style>
